
import { LucideIcon } from 'lucide-react';

interface Usage {
  title: string;
  items: string[];
}

interface RepositoryCardProps {
  name: string;
  manager: string;
  icon: LucideIcon;
  role: string;
  usages: Usage[];
}

export const RepositoryCard = ({
  name,
  manager,
  icon: Icon,
  role,
  usages
}: RepositoryCardProps) => {
  return (
    <div className="bg-background/50 backdrop-blur-sm rounded-2xl p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-border/50 group">
      <div className="flex flex-col gap-8">
        {/* En-tête */}
        <div className="flex items-start gap-6">
          <div className="w-16 h-16 bg-gradient-to-br from-brand-orange/20 to-brand-blue/20 dark:from-brand-orange/10 dark:to-brand-blue/10 rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300">
            <Icon className="w-8 h-8 text-brand-orange group-hover:scale-110 transition-transform duration-300" />
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <h3 className="text-3xl font-title font-semibold bg-gradient-to-r from-brand-blue to-brand-orange bg-clip-text text-transparent">
                {name}
              </h3>
            </div>
            <p className="text-sm font-medium px-3 py-1 rounded-full bg-brand-orange/10 dark:bg-brand-orange/5 text-brand-orange w-fit">
              {manager}
            </p>
          </div>
        </div>

        {/* Rôle */}
        <div className="bg-gradient-to-r from-brand-blue/5 to-brand-orange/5 dark:from-brand-blue/[0.02] dark:to-brand-orange/[0.02] rounded-xl p-6">
          <p className="text-muted-foreground leading-relaxed">
            {role}
          </p>
        </div>

        {/* Usages */}
        <div className="space-y-6">
          {usages.map((usage, index) => (
            <div key={index} className="space-y-4">
              <h4 className="font-title font-medium text-xl text-foreground flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-brand-orange" />
                {usage.title}
              </h4>
              <ul className="grid gap-3 pl-4">
                {usage.items.map((item, itemIndex) => (
                  <li 
                    key={itemIndex} 
                    className="text-muted-foreground flex items-start gap-3 p-3 rounded-lg hover:bg-brand-orange/5 transition-colors duration-200"
                  >
                    <span className="text-brand-orange flex-shrink-0 mt-1">•</span>
                    <span className="leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
